// extracted by mini-css-extract-plugin
export var dividerLine = "_5k-0";
export var errorBackground = "_5k-1";